import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/37/thumb-landscape.jpg"

const Post37 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">BOTTEGA VENETA／パデッドカセット／24 x15 x6cm</span>  
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
            BOTTEGA VENETA／ボッテガ・ヴェネタは、50年以上の歴史をもつイタリアを代表するブランドです。
            2019年の秋冬コレクションからクリエイティブ・ディレクターを担当しているダニエル・リーによって、ボッテガ・ヴェネタは新しい世界観を打ち出しています。洗練されたダニエル・リーのクリエイションは世界中の人々を魅了。新しく生まれ変わったボッテガ・ヴェネタを指すハッシュタグ「#newbottega」が浸透しています。インスタグラムで一般ユーザーが始めたアカウント@newbottegaのフォロワーは40万人超えのアカウントに成長！（2021年1月現在）世界中を魅了するダニエル・リーが手掛けた#newbottegaのバッグをご紹介します。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-two-cloumn">
          <h2>カセット</h2>
          <p>ボッテガといえば、レザーをメッシュ編みにした「イントレチャート」。メッシュが従来のものより幅広になったことで、新鮮味を感じます。こちらのカセットはシンプルでクリーンなイメージ。パデッド カセットはぷくぷくとした膨らみのある中綿入りで可愛らしい雰囲気です。</p>
        </div>
        <figure>
          <StaticImage src="../../images/posts/37/1.jpg" alt="" />
          <span className="text-center">BOTTEGA VENETA／カセット／22 x14 x5cm</span>  
        </figure>
        <div className="img-two-cloumn">
          <figure>
            <StaticImage src="../../images/posts/37/2.jpg" alt="" />
          </figure>
          <figure>
            <StaticImage src="../../images/posts/37/3.jpg" alt="" />
          </figure>
        </div>
        <Link to="https://laxus.co/app/pc/bags/bottega_veneta" className="view-all-button">
          ボッテガ・ヴェネタのバッグを見る
        </Link>
        <div className="text-two-cloumn">
          <h2>ザ・ポーチ</h2>
          <p>柔らかなナッパレザーを使用した「ザ・ポーチ」シリーズ。各国のおしゃれセレブが愛用している姿をたびたびキャッチされています。ミニはクロスボディでも楽しめるのが大きな特徴。クラッチ持ちに慣れていない方でも無理なくチャレンジできそうです。</p>
        </div>
        <figure>
          <StaticImage src="../../images/posts/37/4.jpg" alt="" />
          <span className="text-center">BOTTEGA VENETA／ミニザポーチ／22 x14 x5cm</span>  
        </figure>
        <div className="img-two-cloumn">
          <figure>
            <StaticImage src="../../images/posts/37/5.jpg" alt="" />
          </figure>
          <figure>
            <StaticImage src="../../images/posts/37/6.jpg" alt="" />
          </figure>
        </div>
        <p className="text-max-width">定番サイズにチェーンが付いたタイプ。かなり太めのチェーンなので、正直なところ重さを感じます。しかし、コレを選ぶなら実用性よりファッション性を重視したいところ。重いなんて言ってられない！</p>
        <figure>
          <StaticImage src="../../images/posts/37/7.jpg" alt="" />
          <span className="text-center">BOTTEGA VENETA／ザチェーンポーチ／29 x10 x9cm</span>  
        </figure>
        <p className="text-max-width">そして最後に王道の定番サイズ。間口にたっぷりと寄せたギャザーで、独特のフォルムを表現しています。マグネットフレームのおかげでけ閉めも簡単。オシャレなのはもちろんですが、軽くて、使いやすそうなバッグです。流行っているのも納得！</p>
        <figure>
          <StaticImage src="../../images/posts/37/8.jpg" alt="" />
          <span className="text-center">BOTTEGA VENETA／ザポーチ／36 x18 x8cm</span>  
        </figure>
        <figure>
          <StaticImage src="../../images/posts/37/9.jpg" alt="" />
        </figure>
        <div className="text-two-cloumn">
          <h2>ザ・アルコ</h2>
          <p>ザ・アルコのイントレチャートは特大幅。チューブ状の長いハンドルが描く曲線が、デザインを印象づけます。肩掛けできる利便性の高さから、お仕事バッグにもピッタリです。</p>
        </div>
        <figure>
          <StaticImage src="../../images/posts/37/10.jpg" alt="" />
          <span className="text-center">BOTTEGA VENETA／ミニザアルコ／23 x17 x9cm</span>  
        </figure>
        <div className="text-two-cloumn">
          <h2>ザ・アルコ トート</h2>
          <p>こちらはシンプルなトートタイプ。スッキリとしたデザインでUNISEXで楽しめそう。華美な要素はないけれど、美しいバッグです。</p>
        </div>
        <figure>
          <StaticImage src="../../images/posts/37/11.jpg" alt="" />
          <span className="text-center">
            左から<br></br>
            BOTTEGA VENETA／ザアルコトート／36 x24 x12cm<br></br>
            BOTTEGA VENETA／ラージアルコトートバッグ／44 x34 x11cm
          </span>  
        </figure>
        <p className="text-max-width">かなりしっかりした作りでタフな使用にも耐えてくれそうな頼もしさ。しかし反面、とっても重いです。車移動が多い方なら、問題ないですね！</p>
        <div className="img-two-cloumn">
          <figure>
            <StaticImage src="../../images/posts/37/12.jpg" alt="" />
          </figure>
          <figure>
            <StaticImage src="../../images/posts/37/13.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">BOTTEGA VENETA／ラージアルコトートバッグ／44 x34 x11cm</span>  
        <p className="text-max-width">一方こちらは、柔らかいレザーで軽い！大きさの違いはあるものの、重さが全く違います。一回り小さいものの、PCも余裕で入るので使い勝手は◎</p>
        <div className="img-two-cloumn">
          <figure>
            <StaticImage src="../../images/posts/37/14.jpg" alt="" />
          </figure>
          <figure>
            <StaticImage src="../../images/posts/37/15.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">BOTTEGA VENETA／ザアルコトート／36 x24 x12cm</span>  
        <Link to="https://laxus.co/app/pc/bags/bottega_veneta" className="view-all-button">
          ボッテガ・ヴェネタのバッグを見る
        </Link>
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post37

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 37}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
